import { Chain, Timeframe } from '@ankr.com/chains-list';
import { memo } from 'react';

import { IProjectWithBlockchains } from 'domains/projects/types';
import { JWT } from 'domains/jwtToken/types';

import { EChainView } from '../../../ChainViewSelector';
import { PrivateChainCard } from '../PrivateChainCard';

export interface IProcessedChainsProps {
  hasPremium: boolean;
  processedChains: Chain[];
  projects: JWT[];
  projectsLoading: boolean;
  projectsWithBlockchains: IProjectWithBlockchains[];
  timeframe: Timeframe;
  view?: EChainView;
}

export const ProcessedChains = memo(
  ({
    hasPremium,
    processedChains,
    projects,
    projectsLoading,
    projectsWithBlockchains,
    timeframe,
    view,
  }: IProcessedChainsProps) => {
    return (
      <>
        {processedChains.map(chain => (
          <PrivateChainCard
            chain={chain}
            hasPremium={hasPremium}
            key={chain.id}
            projects={projects}
            projectsLoading={projectsLoading}
            projectsWithBlockchains={projectsWithBlockchains}
            timeframe={timeframe}
            view={view}
          />
        ))}
      </>
    );
  },
);

ProcessedChains.displayName = 'ProcessedChains';
